import API, {config, baseURL, activeToken} from './_main';
import * as VehiclesModule from './../Modules/VehiclesModule';
import {store} from 'Redux/Store';
import {Types} from "Models/TerminalInstallationModel";
import TurnOffTerminal = Types.TurnOffTerminal;
import {CancelToken} from "axios";

export function getCars(params?: URLSearchParams, cancelToken?: CancelToken): Promise<VehiclesModule.Types.PaginatedListCarDto> {
    return API.get('car', { ...config(params), cancelToken }).then((response: any) => response.data);
}

export function fetchFilteredCars(params?: URLSearchParams): Promise<VehiclesModule.Types.PaginatedListCarDto> {
    return API.get('car/filtered', config(params)).then((response: any) => response.data);
}

export function addCar(carData: VehiclesModule.Types.AddCarRequest) {
    return API.post('car', carData, config());
}

export function updateCarData(carUpdatedData: VehiclesModule.Types.UpdateCarRequest, carId: number) {
    return API.post(`car/${carId}`, carUpdatedData, config());
}

export function deleteCar(carId: number) {
    return API.delete(`car/${carId}`, config());
}

export function addCarName(name: string, carId: number) {
    return API.post(`car/${carId}/name`, {name}, config());
}

export function getSingleCarDetails(carId: number) {
    return API.get(`car/${carId}`, config());
}

export function getSingleCarDetailsInfo(carId: number) {
    return API.get(`car/${carId}/info`, config());
}

export function getSingleCarLastTravel(carId: number) {
    return API.get(`car/${carId}/info/last-travel`, config());
}

export function getSingleCarWeekMileage(carId: number) {
    return API.get(`car/${carId}/info/week-mileage`, config());
}

export function getSingleCarMonthMileage(carId: number) {
    return API.get(`car/${carId}/info/month-mileage`, config());
}

export function addCarImage(carId: number, data: FormData) {
    return API.post(`file/car/${carId}/photo`, data, config());
}

export function getSingleCarImages(carId: number) {
    return API.get(`car/${carId}/photo`, config());
}

export function getSingleImage(guid: string) {
    return API.get(`file/${guid}`, config());
}

export function deleteImage(guid: string) {
    return API.delete(`file/${guid}`, config());
}

export function getCarById(carId: number) {
    return API.get(`car/${carId}`, config());
}

export function turnOffCar(carId: number, turnOffData: TurnOffTerminal) {
    return API.put(`car/${carId}/turn-off`, turnOffData, config());
}

export function turnOnCar(carId: number) {
    return API.patch(`car/${carId}/turn-on`);
}

export function turnOffSim(msisdn: string) {
    return API.post(`sim-card/turn-off`, {
        msisdn
    }, config());
}

export function getFileBase(file: any): any {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const urlAddress: string = `${baseURL}/file/${file.guid}`;
        xhr.open('GET', urlAddress, true);
        xhr.responseType = 'blob';
        xhr.setRequestHeader('Authorization', `Bearer ${store.getState().userStore.token}`);
        xhr.setRequestHeader('Content-Type', `${file.mimeType}`);
        xhr.onload = function (e) {
            if (this.status === 200) {
                resolve(this);
            } else {
                // console.log(this);
            }
        };
        xhr.send();
    });
}

export function openWSSWithCarDiagnostic(carId): EventSource {
    return new EventSource(`${baseURL}/sse/car/${carId}?token=${activeToken}`, {withCredentials: true});
}



// WEBPACK FOOTER //
// ./src/Connectors/VehicleConnector.ts